import { leaderboardKey } from '../features/leaderboard';
import { telemetryTracksKey } from '../features/telemetryContext';

import { parseCircuitRouteId } from './circuitRoute';
import { globalTrackContributionsListKey, trackContributionDetailKey } from './trackContributions';

export function circuitDetailRequestKeys(routeId: string | undefined) {
  const circuitId = parseCircuitRouteId(routeId);

  return {
    circuitId,
    contribution: trackContributionDetailKey(circuitId),
    leaderboard: circuitId ? leaderboardKey : null,
    tracks: circuitId ? telemetryTracksKey : null,
    summaries: circuitId ? globalTrackContributionsListKey('summary') : null,
  };
}
